var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-chevron-right",
  "use": "ring-icon-chevron-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-chevron-right\"><path d=\"M10.916 8a.31.31 0 0 1-.101.23L6.146 12.9a.313.313 0 0 1-.46 0l-.501-.502a.32.32 0 0 1-.101-.229c0-.085.034-.164.101-.231L9.123 8 5.185 4.062a.316.316 0 0 1-.101-.23c0-.086.034-.163.101-.23l.501-.502a.318.318 0 0 1 .231-.1c.087 0 .162.034.229.1l4.669 4.669a.318.318 0 0 1 .101.231z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id